export default __webpack_public_path__ + "static/media/woman_climbing.55e49803.jpg";